import axios from 'axios'
import router from '../router'

export const http = axios.create({
  baseURL: 'http://203.95.222.126:5400/api/v1',
  timeout: 10000
})

// Add a request interceptor
http.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// Add a response interceptor
http.interceptors.response.use((response) => { return response }, function (error) {
  // const originalRequest = error.config
  // && originalRequest.url === 'http://13.232.130.60:8081/v1/auth/token) {
  if (error.response.status === 401) {
    router.push('/user/login')
  }
  return Promise.reject(error)
})
